import {
  Box,
  Flex,
  Text,
  IconButton,
  Button,
  Stack,
  Collapse,
  Icon,
  Link,
  Popover,
  PopoverTrigger,
  PopoverContent,
  useColorModeValue,
  useBreakpointValue,
  useDisclosure,
  Image,
  Input,
  HStack,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
} from "@chakra-ui/react";
import {AiOutlineSearch} from "react-icons/ai"
import "../Pages/homepage.css";
import {
  HamburgerIcon,
  CloseIcon,
  ChevronDownIcon,
  ChevronRightIcon,
  EmailIcon,
} from "@chakra-ui/icons";
import { Link as MyLink } from "react-router-dom";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
export default function WithSubnavigation() {
  const { isOpen, onToggle } = useDisclosure();
  
  return (
    <Box w={{ base: "100%", md: "100%" }} margin="auto"  boxShadow='0 4px 8px rgba(76, 77, 78, 0.3)' position='sticky'>
      <Flex
        w={{ base: '100%', md: "85%" }}
        margin='auto'
        bg={useColorModeValue("white", "gray.800")}
        color={useColorModeValue("gray.600", "white")}
        minH={"60px"}
        py={{ base: 2 }}
        // px={{ base: 4 }}
        borderBottom={1}
        borderStyle={"solid"}
        borderColor={useColorModeValue("gray.200", "gray.900")}
        justify='space-between'
        align={"center"}
      >
        <Flex flex={{ base: 1 }} justify={"start"}>
          <MyLink to="/">
            <Image
              src="https://ketto.gumlet.io/assets/images/logo-light-bg.svg?w=70&dpr=1.0"
              w="65px"
            />
          </MyLink>
          <Flex display={{ base: "none", md: "flex" }}
            ml={10}
            spacing='2'
            w='100%'
            // justify='space-evenly'
            // border='1px solid grey'
          >
            <DesktopNav />
          </Flex>
        </Flex>
        <Flex
          flex={{ base: 1, md: "auto" }}
          ml={{ base: -2 }}
          justify={"flex-end"}
          display={{ base: "flex", md: "none" }}
        >
          <IconButton
            onClick={onToggle}
            icon={
              isOpen ? <CloseIcon w={3} h={3} /> : <HamburgerIcon w={5} h={5} />
            }
            variant={"ghost"}
            aria-label={"Toggle Navigation"}
          />
        </Flex>
      </Flex>

      <Collapse in={isOpen} animateOpacity>
        <MobileNav />
      </Collapse>
    </Box>
  );
}

const DesktopNav = () => {
  const linkColor = useColorModeValue("gray.600", "gray.200");
  const linkHoverColor = useColorModeValue("gray.800", "white");
  const popoverContentBgColor = useColorModeValue("white", "gray.800");
  const isAuth = useSelector(state => state.authReducer.isAuth);
  
  return (
    <Stack direction={"row"} spacing={1} align="center" justify='space-between'>
      {NAV_ITEMS.filter(
        (navItem) =>
          navItem.label !== "Sign In" || navItem.label !== "Get us on Whatsapp"
      ).map((navItem) => (
        <Box key={navItem.label}>
          <Popover trigger={"hover"} placement={"bottom-start"}>
            <PopoverTrigger>
              <Link
                p={2}
                href={navItem.href ?? "#"}
                fontSize={"md"}
                fontWeight={400}
                color={linkColor}
                _hover={{
                  textDecoration: "none",
                  color: linkHoverColor,
                }}
              >
                {navItem.label}
                {navItem.label === "Fundraiser For" ? (
                  <Icon color={"#01BFBD"} w={5} h={5} as={ChevronDownIcon} />
                ) : (
                  ""
                )}
              </Link>
            </PopoverTrigger>

            {navItem.children && (
              <PopoverContent
                border={0}
                boxShadow={"xl"}
                bg={popoverContentBgColor}
                p={4}
                lineHeight="2px"
                rounded={"xl"}
                maxW={"max-content"}
              >
                <Stack>
                  {navItem.children.map((child) => (
                   <DesktopSubNav key={child.label} {...child} />
                  ))}
                </Stack>
              </PopoverContent>
            )}
          </Popover>
        </Box>
      ))}
      <Box>|</Box>
      <HStack>
        <Input as='input'type="text" placeholder="Search" borderRadius={'10px'} width='160px'  />
        <AiOutlineSearch size='25px' />
      </HStack>

      {/* <Box w="50px"></Box> */}
      <Button className='rs-skyblue-btn' border='2px solid #16e053' color='#16e053'style={{  paddingTop: '2%' }} _hover={{backgroundColor: '#0eb942',color:'white'}}>Chat</Button>

      <Button className='rs-skyblue-btn' border='2px solid #01BFBD' color='#01BFBD'style={{paddingTop:'2%'}} _hover={{backgroundColor: '#01BFBD',color:'white'}}><Link
        href="/medical"
        _hover={{
                  textDecoration: 'none',
                  color: linkHoverColor,
                }}>Start Fundraiser</Link></Button>

      {!isAuth ? <Button
        as={"a"}
        fontSize={"sm"}
        fontWeight={400}
        variant={"link"}
        href={"/login"}
      >
        Sign In
      </Button>
        :
        <Menu >
          <MenuButton as={Button} rightIcon={<ChevronDownIcon />}>
            <img
              src="https://i.postimg.cc/nMQTLpMb/person-filled-FILL0-wght400-GRAD0-opsz48.png"
              style={{ width: "30px", height: "30px" }}
            />
          </MenuButton>
          <MenuList zIndex={1}>
            <MenuItem>View Profile</MenuItem>
            <hr />
            <MenuItem>My Fundraisers</MenuItem>
            <hr />
            <MenuItem>My Donations</MenuItem>
            <hr />
            <MenuItem>View My Impact</MenuItem>
            <hr />
            <Flex>
              <img
                src="https://w7.pngwing.com/pngs/672/164/png-transparent-whatsapp-icon-whatsapp-logo-computer-icons-zubees-halal-foods-whatsapp-text-circle-unified-payments-interface-thumbnail.png"
                style={{ width: "30px", height: "25px", marginTop: "5px", marginLeft: "5px" }}
              />
              <MenuItem color="green.500">Get us on Whatsapp</MenuItem>
            </Flex>

            <hr />
            <MenuItem>{isAuth?"LogOut":"Login"}</MenuItem>
          </MenuList>
        </Menu>
      }
    </Stack>
    // 
  );
};

const DesktopSubNav = ({ label, href, subLabel }) => {
  return (
    <Link
      href={href}
      role={"group"}
      display={"block"}
      p={2}
      rounded={"md"}
      textDecoration="none"
      _hover={{
        textDecoration: "none",
      }}
      // _hover={{ bg: useColorModeValue('#01BFBD', '#01BFBD') }}
    >
      <Stack direction={"row"} align={"center"}>
        <Box>
          <Text
            transition={"all .3s ease"}
            _groupHover={{ color: "#01BFBD" }}
            fontWeight={400}
          >
            {label}
          </Text>
          <Text fontSize={"sm"}>{subLabel}</Text>
        </Box>
      </Stack>
    </Link>
  );
};

const MobileNav = () => {
  const isAuth = useSelector(state => state.authReducer.isAuth);

  return (
    <Stack
      bg={useColorModeValue("white", "gray.800")}
      p={4}
      w="100%"
      justify="left"
      display={{ md: "none" }}
    >
      <Input
        placeholder="Search by fundraisers, fundraiser creator, beneficiary or NGOs"
        b="none"
        bg="gray.100"
        w="100%"
      />
      <HStack>
        <MobileNavItem
          key={"Click"}
          label="To view fundraisers you have supported on Ketto"
        />
        <Link to="" fontWeight="500" color="#01BFBD">
          Click here
        </Link>
      </HStack>
      {NAV_ITEMS.map((navItem) => (
        <MobileNavItem key={navItem.label} {...navItem} />
      ))}
    
      <MobileNavItem key={"whatsapp"} label="Get us on Whatsapp" href="#"/>
      <MobileNavItem key={"Click"} label={isAuth?"Sign In":"Log Out"} href="/login"/>
      <Button className='rs-skyblue-btn' style={{backgroundColor: '#01BFBD'}}><MyLink to="/medical">Start A Fundraiser</MyLink></Button>
    </Stack>
  );
};

const MobileNavItem = ({ label, children, href }) => {
  const { isOpen, onToggle } = useDisclosure();

  return (
    <Stack spacing={4} onClick={children && onToggle}>
      <Flex
        py={2}
        as={Link}
        href={href ?? "#"}
        justify={"space-between"}
        align={"center"}
        _hover={{
          textDecoration: "none",
          color: "#01BFBD",
        }}
      >
        <Text
          fontWeight={600}
          color={useColorModeValue("gray.600", "gray.200")}
        >
          {label}
        </Text>
        {children && (
          <Icon
            as={ChevronDownIcon}
            transition={"all .25s ease-in-out"}
            transform={isOpen ? "rotate(180deg)" : ""}
            w={6}
            h={6}
          />
        )}
      </Flex>

      <Collapse in={isOpen} animateOpacity style={{ marginTop: "0!important" }}>
        <Stack
          mt={2}
          pl={4}
          borderLeft={1}
          borderStyle={"solid"}
          borderColor={useColorModeValue("gray.200", "gray.700")}
          align={"start"}
        >
          {children &&
            children.map((child) => (
              <Link
                key={child.label}
                py={2}
                href={child.href}
                _hover={{
                  textDecoration: "none",
                  color: "#01BFBD",
                }}
              >
                {child.label}
              </Link>
            ))}
        </Stack>
      </Collapse>
    </Stack>
  );
};

const NAV_ITEMS = [
  {
    label: "Browse Fundraisers",
    href: "/fundraise",
  },

  {
    label: "Fundraiser For",
    children: [
     
      {
        label: 'Medical Treatment',
        href: '/medical',
      },
      {
        label: 'NGO / Charity',
        href: '/medical',
      },
      {
        label: 'Other Cause',
        href: '/medical',
      },
    ],
  },
  {
    label: "How It Works",
    href: "#",
  },
  // {
  //   label: 'Get us on Whatsapp',
  //   href: '#',
  // },
  // {
  //   label: 'Sign In',
  //   href: '#',
  // },
];
